import { Box, List, ListItem, Typography } from "@mui/material";

import type { FC } from "react";

export const P2pModalContent: FC = () => (
  <Box>
    <Typography variant="body2" sx={{ fontWeight: 700 }}>
      Make it easy for employees to recognize each other
    </Typography>
    <Typography sx={{ mt: 2 }} variant="body2">
      Peer recognition is something teams ask for often, but rolling out a full employee platform
      usually means logins, training, and ongoing admin work.
    </Typography>
    <Typography sx={{ mt: 2 }} variant="body2">
      ChangeEngine takes a lighter approach.
    </Typography>
    <Typography sx={{ mt: 2 }} variant="body2">
      With Peer-to-Peer Recognition, you can:
      <List sx={{ listStyleType: "disc", pl: 4 }}>
        <ListItem sx={{ display: "list-item" }}>
          Collect peer nominations through simple surveys
        </ListItem>
        <ListItem sx={{ display: "list-item" }}>
          See who’s being recognized and why in a dedicated dashboard
        </ListItem>
        <ListItem sx={{ display: "list-item" }}>Identify recognition trends across teams</ListItem>
        <ListItem sx={{ display: "list-item" }}>
          Connect nominations to e-gifting so managers can easily reward great work
        </ListItem>
      </List>
    </Typography>
    <Typography sx={{ mt: 2 }} variant="body2">
      Everything stays inside ChangeEngine, using workflows you already trust.
    </Typography>
    <Typography variant="body2" sx={{ fontWeight: 700, mt: 2 }}>
      Less overhead. More recognition. Real signals you can act on.
    </Typography>
  </Box>
);
